/* istanbul ignore file */
import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import type { BreadcrumbItemProps } from '../BreadcrumbsTypes';

const NotesBreadcrumbItem = (props: Partial<BreadcrumbItemProps>) => {
  return <BreadcrumbItem {...props}>Notes</BreadcrumbItem>;
};

export default NotesBreadcrumbItem;
